<template>
    <div class="qingwu festival_home">



<!-- 楼层 -->
<div class="louceng">
<div class="tip">
<ol id="floorNavList">
          <li
          class="nav-list-item"
          v-for="(item, index) in floorList"
          :key="item.id"
          @click="setFloorNavMountClick(index)"
          >{{ item.name }}</li>
</ol>
<ul>
<el-backtop style="right: auto; bottom: auto;">
<li style="line-height: 14px; border-bottom: none;">返回顶部</li>
</el-backtop>
</ul>
</div>
</div>
<!-- 楼层end -->

<div class="shop_top"><shop-top :subnav_show="subnav_show"></shop-top></div>
<div class="content" style="margin: 0 auto !important; z-index:99;">
<!--右侧方块-->
<div class="sideright">
<div class="tab-boxs">
  <el-tabs v-model="siderighttabs">
    <el-tab-pane label="活动" name="first">

		<div class="event">
<!-- <a v-for="(v,k) in right_menu1" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a> -->
			<li v-for="(v,k) in rightmenu1" :key="k"><a :href="v.adUrl"><img :src="filePath + v.adImage"></a></li>
      <li v-for="(v,k) in rightmenu2" :key="k"><a :href="v.adUrl"><img :src="filePath + v.adImage"></a></li>
      <li v-for="(v,k) in rightmenu3" :key="k"><a :href="v.adUrl"><img :src="filePath + v.adImage"></a></li>
		</div>


    </el-tab-pane>
    <el-tab-pane label="公告" name="second">
		<div class="item">
    <div class="rannouncement">
      <a href="/news/info/53?className=%E9%80%9A%E7%9F%A5%E5%85%AC%E5%91%8A" target="_blank"><img src="pc/2020/imgs/rannouncement.jpg"></a>
    </div>
	<div class="announcement">
		<ul>

      <li v-for="v in announcement.slice(0, 5)" :key="v.id" v-show="v.isshow == true">
      <a  :href="'/news/info/'+v.id+'?className=通知公告'" target="_blank" :title="v.newsTitle">{{v.newsTitle | ellipsis}}</a>
      <!--<a :href="v.url" class="topnewstys">{{v.date | formatDate('yyyy-MM-dd')}}</a>-->
      </li>
      <span @click="viewMoreNews()" class="more" style="float:right">更多消息</span>
		</ul>
	</div>
		</div>
    </el-tab-pane>
  </el-tabs>


	
</div>	
</div>
<!--右侧方块-->
</div>

<div><banner :list="banner_list"></banner></div>

<!--本周优选-->
	<div class="content" v-show="!skillShow">
	<div class="miaosha">
		<!-- <div class="title clear">
      <h2><a href="special/list/MjAyMDEwMTNfMTc="><img src="pc/2020/imgs/miaosha.png"></a></h2>
      <span class="countdown">
          <font>距离{{fontSkill}} <span class="skill_time">{{hour}}:{{min}}:{{secs}}</span></font>
      </span>
      </div> -->
    <div class="title clear"><h2><a href="special/list/MjAyMTA4MDVfNDc="><img src="pc/2020/imgs/youxuan.png"></a></h2></div>
			<div class="product clear">
			<ul v-if="best_week">
	<li v-for="v in best_week.slice(0, 5)" :key="v.id">
    <router-link :to="'/goods/info/'+v.id" target="_blank">
      <div class="fl">
        <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image></div>
      <div class="fr">
        <p class="title">{{v.name}}</p>
        <p class="ftitle">规格：{{v.spec}}</p>
        <p class="mony1" v-if="v.is_ControlSales == false">授权查看</p>
        <p class="mony1" v-else-if="v.price == null && v.nowprice == null">会员可见</p>
        <p class="mony" v-else-if="v.nowprice == null && v.price != null"><span class="fl"><i>￥</i>{{v.price}}</span><span class="fr"></span></p>
        <p class="mony" v-else><span class="fl"><i>￥</i>{{v.nowprice}}</span><span class="fr"><i>￥</i>{{v.price}}</span></p>
        

      </div>
    </router-link>
	</li>
 
			</ul>
			</div>		
	</div>
	</div>
<!--本周优选 end-->

<!--限时秒杀-->
	<div class="content" v-show="skillShow">
	<div class="miaosha">
		<div class="title clear">
      <h2><a href="special/list/MjAyMDEwMTNfMTc="><img src="pc/2020/imgs/miaosha.png"></a></h2>
      <span class="countdown">
          <font>距离{{fontSkill}} <span class="skill_time">{{hour}}:{{min}}:{{secs}}</span></font>
          <!-- <font>{{v.is_active?'活动中':'即将开始'}}</font> -->
      </span>
      </div>
    <!-- <div class="title clear"><h2><a href="special/list/MjAyMDEwMTNfMTc="><img src="pc/2020/imgs/youxuan.png"></a></h2></div> -->
			<div class="product clear">
			<ul v-if="seckill">
	<li v-for="v in seckill.slice(0, 5)" :key="v.id">
    <router-link :to="'/goods/info/'+v.id" target="_blank">
      <div class="fl">
        <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image></div>
      <div class="fr">
        <p class="title">{{v.name}}</p>
        <p class="ftitle">规格：{{v.spec}}</p>
        <p class="mony1" v-if="v.is_ControlSales == false">授权查看</p>
        <p class="mony1" v-else-if="v.price == null && v.nowprice == null">会员可见</p>
        <p class="mony" v-else-if="v.nowprice == null && v.price != null"><span class="fl"><i>￥</i>{{v.price}}</span><span class="fr"></span></p>
        <p class="mony" v-else><span class="fl"><i>￥</i>{{v.nowprice}}</span><span class="fr"><i>￥</i>{{v.price}}</span></p>
        

      </div>
    </router-link>
	</li>
 
			</ul>
			</div>		
	</div>
	</div>
<!--限时秒杀 end-->



<!--一行四个按钮-->
<div class="content clear  project1">
	<div class="menu">
		<ul>
<li><a v-for="(v,k) in button_menu1" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a></li>
<li><a v-for="(v,k) in button_menu2" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a></li>
<li><a v-for="(v,k) in button_menu3" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a></li>
<li><a v-for="(v,k) in button_menu4" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a></li>
			<!-- <li><a href="special/list/MjAyMDEwMjJfMTg=" target="_blank"><img src="pc/2020/imgs/menu1.png"></a></li>
			<li><a href="special/list/MjAyMDEwMjJfMTk=" target="_blank"><img src="pc/2020/imgs/menu2.png"></a></li>
			<li><a href="special/list/MjAyMDEwMjJfMjA=" target="_blank"><img src="pc/2020/imgs/menu3.png"></a></li>
			<li><a href="special/list/MjAyMDEwMjJfMjE=" target="_blank"><img src="pc/2020/imgs/menu4.png"></a></li> -->
		</ul>
	</div>
	
</div>
<!--一行四个按钮end-->

<!--一行三列-->

<!--领券中心-

	<div class="floor-item project2 content clear">
	
		<div class="coupon fl">
			<div class="title">
				<h2>领券中心<span class="fr"><a href="coupon/" target="_blank">更多></a></span></h2>
			</div>
			<div class="vouchers">
				<a href="coupon/" target="_blank"><img src="pc/2020/imgs/vouchers.jpg" title="领券中心"></a>
			</div>

		</div>
		<div class="sales fl">
			
			<div class="title">
				<h2>促销专场</h2>
			</div>
			
			<div class="cuxiao">
			<ul>
<li> 
<a v-for="(v,k) in Promotion_1" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
</li>
<li> 
<a v-for="(v,k) in Promotion_2" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
</li>
<li> 
<a v-for="(v,k) in Promotion_3" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
</li>
<li> 
<a v-for="(v,k) in Promotion_4" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
</li>
			</ul>
				
			</div>
			
		</div>
		<div class="ranking fr">
			
			<div class="title">
				<h2>排行榜</h2>
			</div>
			

<div class="tab-box">
  <el-tabs v-model="activeName">
    <el-tab-pane label="药店热销" name="first" class="action">
		<div class="item">
			<div class="product">
			<ul v-if="drugstore_sales">
            <li v-for="v in drugstore_sales.slice(0, 3)" :key="v.id">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <div class="fl"><img :src="filePath + v.img" :alt="v.name" :title="v.name"></div>
                <div class="fr">
                    <p class="title">{{v.name}}</p>
                    <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="company">{{v.company_name}}</p>
                    <p class="buy">
                    <span>立即购买</span></p>
                </div>
                </router-link>

            </li>  

			</ul>	
			</div>
		</div>
    </el-tab-pane>
    <el-tab-pane label="诊所常卖" name="second">
		<div class="item">
			<div class="product">
			<ul v-if="clinic_sells">
            <li v-for="v in clinic_sells.slice(0, 3)" :key="v.id">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <div class="fl"><img :src="filePath + v.img" :alt="v.name" :title="v.name"></div>
                <div class="fr">
                    <p class="title">{{v.name}}</p>
                    <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="company">{{v.company_name}}</p>
                    <p class="buy">
                    <span>立即购买</span></p>
                </div>
                </router-link>
            </li>  

			</ul>	
			</div>
		</div>
    </el-tab-pane>
  </el-tabs>


	
</div>	
	
	

			
			
			
		</div>
		
		
	</div>
	
一行三列结束-->


<!--通栏一AD-->
<!-- <div class="content ad" v-if="floor_ad_1">
<a v-for="(v,k) in floor_ad_1" :key="k" :href="v.adUrl" >
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
</div> -->
<!--通栏一ADend-->

<!--新品推荐-->
<!-- 新品上架-->

	<div class="floor-item content newp clear">
    <div class="title clear"><h2>新品推荐<span class="fr"><a href="special/list/MjAyMDEwMTNfMTE=" target="_blank">更多></a></span></h2></div>

    <div class="fl">
      <div class="focus">
        <el-carousel :interval="5000" arrow="always" height="450px">
          <el-carousel-item v-for="v in newproduct_focus" :key="v.id">
            <router-link :to="v.adUrl">
              <el-image :src="filePath + v.adImage" :alt="v.adName" :title="v.adName">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              </el-image>
            </router-link>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="fr">
      <div class="product">
        <ul v-if="newproduct_list">
          <li v-for="v in newproduct_list.slice(0, 5)" :key="v.id">
            <router-link :to="'/goods/info/'+v.id" target="_blank">
              <div class="fl">
                <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="fr">
                <p class="title">{{v.name}}</p>
                <p class="ftitle">规格：{{v.spec}}</p>
                <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      
    </div>
		
	</div>
<!--新品推荐end-->

<!--通栏二AD-->
<div class="content ad" v-if="floor_ad_2">
<a v-for="(v,k) in floor_ad_2" :key="k" :href="v.adUrl">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
<!-- <el-image :width="v.adpWidth" :height="v.adpHeight" :src="v.adImage" :alt="v.adName"></el-image> -->
</a>
</div>
<!--adend-->

<!--为您推荐-->
<div class="content recommended">
	<div class="fl"><a href="special/list/MjAyMDEwMTNfMTI=" target="_blank"><img src="pc/2020/imgs/rolling.jpg"></a></div>
	<div class="fr">
        <div class="rolling">
    <el-carousel height="260px" :autoplay="false" v-if="recommend_list">

<el-carousel-item v-if="recommend_list.length>0">
	<li v-for="v in recommend_list.slice(0, 5)" :key="v.id">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                    <p>
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                      </p>
                    <p class="title">{{v.name}}</p>
                    <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </router-link>

	</li>
</el-carousel-item>
<el-carousel-item v-if="recommend_list.length>5">
	<li v-for="v in recommend_list.slice(5, 10)" :key="'item'+v.id">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                    <p>                  
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                  </p>
                    <p class="title">{{v.name}}</p>
                    <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </router-link>
	</li>
</el-carousel-item>
<el-carousel-item v-if="recommend_list.length>10">
	<li v-for="v in recommend_list.slice(10, 15)" :key="'item2'+v.id">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                    <p>
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                    </p>
                    <p class="title">{{v.name}}</p>
                    <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </router-link>
	</li>
</el-carousel-item>

    </el-carousel>
        </div>
	</div>
	
</div>
<!--为您推荐-->



<!--中药饮片-->
	<div class="floor-item content cmedicine clear">
		<div class="title clear"><h2>中药饮片<span class="fr"><a href="special/list/MjAyMDEwMTNfMTQ=" target="_blank">更多></a></span></h2></div>


			<div class="product">
			<ul v-if="tcm_list">
				<li class="first">
<a v-for="(v,k) in tcm_ad" :key="k" :href="v.adUrl">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
					<!-- <a href="special/list/MjAyMDEwMTNfMTQ=" target="_blank"><img src="pc/2020/imgs/cmedicine.jpg"></a> -->
				</li>
            <li v-for="v in tcm_list.slice(0, 6)" :key="v.id">
               <router-link :to="'/goods/info/'+v.id" target="_blank">
                <div class="fl">
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                </div>
                <div class="fr">
                    <p class="title">{{v.name}}</p>
                    <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                    </div>
               </router-link>
            </li>
		
			</ul>
			</div>
	</div>
<!--中药饮片end-->


<!--通栏三-->
<div class="content ad" v-if="floor_ad_4">
<a v-for="(v,k) in floor_ad_4" :key="k" :href="v.adUrl">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
<!-- <el-image :width="v.adpWidth" :height="v.adpHeight" :src="v.adImage" :alt="v.adName"></el-image> -->
</a>
</div>
<!--adend-->






<!--精品控销，家庭保健-->
<!--精品控销-->

<div class="floor-item content twocolumn clear">
	<div class="control">
		<div class="title clear"><h2>精品控销</h2></div>
		<div class="fl">
<a v-for="(v,k) in control_ad" :key="k" :href="v.adUrl">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
      <!-- <a href="control/"><img src="pc/2020/imgs/control.jpg"></a> -->
      </div>
		<div class="fr">
			<div class="jingpin" v-if="control_sales">
  <el-table
    :data="control_sales"
    height="340"
    border
    :default-sort = "{prop: 'name'}"
    style="width: 100%">
    <el-table-column
      prop="name"
      sortable
      label="名称"
      width="100">
        <template slot-scope="scope">
          <router-link to="control/"
            target="_blank"
            class="buttonText">{{scope.row.name}}</router-link>
        </template>
    </el-table-column>
    <el-table-column
      prop="company_name"
      label="厂家"
      sortable
      width="195">
        <template slot-scope="scope">
          <router-link to="control/"
            target="_blank"
            class="buttonText">{{scope.row.company_name}}</router-link>
        </template>
    </el-table-column>
  </el-table>				

			</div>
			
		</div>
	</div>
	<div class="family">
		<div class="title clear"><h2>家庭保健<span class="fr" style="text-align: right"><a href="special/list/MjAyMDEwMTNfMTM=" target="_blank">更多></a></span></h2></div>
		<div class="fl">
<a v-for="(v,k) in homehelth_ad" :key="k" :href="v.adUrl">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
      <!-- <a href="goods/params/keyword=钙尔奇钙维D维K软胶囊" target="_blank"><img src="pc/2020/imgs/family.jpg"></a> -->
      </div>
		<div class="fr">
			<div class="product">
            <ul v-if="family_health">
            <li v-for="v in family_health.slice(0, 2)" :key="v.id">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <div class="fl">
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                </div>
                <div class="fr">
                    <p class="title">{{v.name}}</p>
                    <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </div>
                </router-link>
            </li>
            </ul>

			</div>
			
		</div>
	</div>
</div>

<!--精品控销，家庭保健 end-->



<!--诊所特供，家庭保健-->
<!--家庭常备-->



<div class="floor-item content twocolumns clear">
	<div class="control">
		<div class="title clear"><h2>消毒用品<span class="fr"><a href="special/list/MjAyMDEwMTNfMTU=" target="_blank">更多></a></span></h2></div>
		<div class="fl" style="height: 340px;">
<a v-for="(v,k) in qixie_ad" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
      </div>
  <div class="fr" style="height: 340px;">
    <div class="product">
      <ul v-if="household_list">
            <li v-for="v in household_list.slice(0, 2)" :key="v.id">
            <router-link :to="'/goods/info/'+v.id" target="_blank">
                <div class="fl">
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                </div>
                <div class="fr">
                <p class="title">{{v.name}}</p>
                <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </div>
            </router-link>
            </li>
      </ul>
    </div>
  </div>
  <div class="products clear">
    <ul v-if="household_list">
            <li v-for="v in household_list.slice(2, 4)" :key="'item'+v.id">
             <router-link :to="'/goods/info/'+v.id" target="_blank">
            <div class="fl">
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
            </div>
            <div class="fr">
                <p class="title">{{v.name}}</p>
                <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </div>
            </router-link>
            </li>
    </ul>
  </div>

			

			
	
	</div>
	<div class="family">
		<div class="title clear"><h2>女性健康<span class="fr"><a href="special/list/MjAyMDEwMTNfMTY=" target="_blank">更多></a></span></h2></div>
		<div class="fl"  style="height: 340px;">
<a v-for="(v,k) in women_ad" :key="k" :href="v.adUrl" target="_blank">
<img :width="v.adpWidth" :height="v.adpHeight" :src="filePath + v.adImage" :alt="v.adName">
</a>
      </div>
  <div class="fr" style="height: 340px;">
    <div class="product">
      <ul v-if="apparatus_list">
            <li v-for="v in apparatus_list.slice(0, 2)" :key="v.id">
            <router-link :to="'/goods/info/'+v.id" target="_blank">
                <div class="fl">
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                </div>
                <div class="fr">
                <p class="title">{{v.name}}</p>
                <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </div>
            </router-link>
            </li>
      </ul>
    </div>
  </div>
  <div class="products clear">
    <ul v-if="apparatus_list">
            <li v-for="v in apparatus_list.slice(2, 4)" :key="'item'+v.id">
            <router-link :to="'/goods/info/'+v.id" target="_blank">
                <div class="fl">
                  <el-image :src="filePath + v.img" :alt="v.name" :title="v.name">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
                  </el-image>
                </div>
                <div class="fr">
                <p class="title">{{v.name}}</p>
                <p class="ftitle">规格：{{v.spec}}</p>
                    <p class="mony" v-if="v.is_ControlSales == false">授权查看</p>
                    <p class="mony" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</p>
                    <p class="mony" v-else-if="v.nowprice == null && v.price != null"><i>￥</i>{{v.price}}</p>
                    <p class="mony" v-else><i>￥</i>{{v.nowprice}}</p>
                </div>
            </router-link>
            </li>
    </ul>
  </div>
			

	</div>
</div>





<!--诊所特供，家庭保健 end-->

<!--品牌专场-->
	<div class="content brand clear floor-item">
		<div class="title clear"><h2>厂家推荐</h2></div>
<div class="product">
	<ul>
		<li class="first">
		<a href="special/list/MjAyMDExMDlfMjQ=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand1.jpg'">
		<div class="mask"><h3>点击查看</h3></div>
		</div>
		</a>
		</li>
		<li>
		<a href="special/list/MjAyMDExMDlfMjU=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand2.jpg'">
		<div class="mask"><h3>点击查看</h3></div>
		</div>
		</a>
		</li>
		<li>
		<a href="special/list/MjAyMDExMDlfMjY=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand3.jpg'">
		<div class="mask"><h3>点击查看</h3></div>
		</div>
		</a>
		</li>
		<li>
		<a href="special/list/MjAyMDExMDlfMjc=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand4.jpg'">
            <div class="mask"><h3>点击查看</h3></div>
		</div>
		</a>
		</li>
		<li class="first">
		<a href="special/list/MjAyMDExMDlfMjg=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand5.jpg'">
		<div class="mask"><h3>点击查看</h3></div>
		</div>
		</a>
		</li>
		<li>
		<a href="special/list/MjAyMDExMDlfMjk=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand6.jpg'">
		<div class="mask"><h3>点击查看</h3></div>
		</div>
		</a>
		</li>
		<li>
		<a href="special/list/MjAyMDExMDlfMzA=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand7.jpg'">
		<div class="mask"><h3>点击查看</h3></div>
		</div>
		</a>
		</li>
		<li>
		<a href="special/list/MjAyMDExMDlfMzE=" target="_blank">
		<div class="bimg"><img :src="filePath + 'imgs/brand/brand8.jpg'">
            <div class="mask"><h3>点击查看</h3></div>
		</div>

		</a>
		</li>
	</ul>
</div>
		</div>
<!--品牌专场 end-->




        <!-- <banner-bottom-adv :index_adv="banner_bottom_adv"></banner-bottom-adv> -->

        <div class="shop_content">
            <!-- <seckill :list="seckill_goods_list" :info="seckill_info"></seckill>
            <div v-for="(v,k) in goods_list" :key="k">
                <shop-index-adv :adv="goods_list_bottom_adv[k]"></shop-index-adv>
                <shop-product-block :class_info="v.class_info"  :goods_list="v.list" :adv="goods_list_left_adv[k]"></shop-product-block>
            </div>
            <shop-index-adv></shop-index-adv>
            <shop-product-block></shop-product-block> -->


            
            <!--还没逛够-->

          <!-- <div><shop-product-other :list="seckill_goods_list" :key="1"></shop-product-other></div> -->


        </div>

<el-dialog
  class="dialog"
  :visible.sync="dialogVisible"
  :width="width"
  >
  <a v-for="(v,k) in popup" :key="k" :href="v.adUrl" target="_blank" style="width:400px; height:300px; ">
    <img style="width:400px;" :src="filePath + v.adImage" :alt="v.adName" @load="onLoad">
  </a>
  
  <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">前 往</el-button>
  </span> -->
</el-dialog>


        <ShopMbar></ShopMbar>
        <shop-foot></shop-foot>
        <!-- vue 回到顶部1 -->
  
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import banner from "@/components/home/public/banner.vue"
//import BannerBottomAdv from "@/components/home/public/banner_bottom_adv.vue"
//import showAdver1 from "@/components/home/public/showAdver1.vue"
//import seckill from "@/components/home/public/seckill.vue"
//import ShopIndexAdv from "@/components/home/public/shop_index_adv.vue"
//import ShopProductBlock from "@/components/home/public/shop_product_block.vue"
//import ShopProductOther from "@/components/home/public/shop_product_other.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import _ from 'lodash'
import '@/components/style/style.css'
export default {
    components: {
        ShopTop,
        banner,
        //BannerBottomAdv,
        //seckill,
        //ShopIndexAdv,
        //ShopProductBlock,
        //ShopProductOther,
        ShopMbar,
        ShopFoot,
    },
    props: {},
    data() {
      return {
          element: {
          nav_item: null,
          floor_item: null
          },
          popup_num:0,
          timer: null,
          banner_list:[],  // 幻灯片
          //banner_bottom_adv:[], // 三联广告图片
          subnav_show:true,
          goods_list:[],
          //goods_list_left_adv:[],
          //goods_list_bottom_adv:[],
          seckill_goods_list:[], //秒杀
          seckill_info:{},
          activeName: 'first',
          siderighttabs: 'first',
          tableData: [],
            family_health:[],
            announcement:[],
            best_week:[],            //本周优选
            seckill:[],              //限时秒杀
            drugstore_sales:[],      //药店热销
            clinic_sells:[],         //诊所常卖
            newproduct_focus:[],     //新品推荐轮播
            newproduct_list:[],      //新品推荐
            recommend_list:[],       //为你推荐
            control_sales:[],        //精品控销
            tcm_list:[],             //中药饮片
            household_list:[],       //家用器械
            apparatus_list:[],       //中医器械
            brand_list:[],           //品牌专区
            floor_ad_1:null,         //楼层一广告
            floor_ad_2:null,         //楼层二广告
            floor_ad_3:null,         //楼层三广告
            floor_ad_4:null,         //楼层四广告
            Promotion_1:null,        //促销专场广告1
            Promotion_2:null,        //促销专场广告2
            Promotion_3:null,        //促销专场广告4
            Promotion_4:null,        //促销专场广告4
            rightmenu1:null,         //轮播右侧广告1
            rightmenu2:null,         //轮播右侧广告2
            rightmenu3:null,         //轮播右侧广告3
            button_menu1:null,
            button_menu2:null,
            button_menu3:null,
            button_menu4:null,
            floorList: [             // 自定义左侧楼层数
              { id: 1, name: '导航' },
              { id: 2, name: '领券中心' },
              { id: 3, name: '新品上架' },
              { id: 4, name: '中药饮片' },
              { id: 5, name: '家庭保健' },
              { id: 6, name: '消毒用品' },
              { id: 7, name: '厂家推荐' }
           ],
          hour:0,
          min:0,
          secs:0,
          skillShow:true,
          intvalobj:null,
          fontSkill:'开始',
          start_time:null, //秒杀开始时间
          end_time:null,   //秒杀结束时间
          total_data:0, // 总条数
          page_size:10,
          current_page:1,
          filePath:null,
          adshow:false,
          width: '400px',
          dialogVisible:false,
          popup:null,
      };
    },
    filters: {
      ellipsis (value) {
          if (!value) return ''
          if (value.length > 13) {
              return value.slice(0, 13) + '...'
          }
          return value
      }
    },
    watch: {},
    computed: {},
    beforeDestroy() { //在组件生命周期结束的时候销毁。
            window.removeEventListener('scroll', this.floorSrcollEventListener);
        },
    //本周优选排序
    best_weeks: function () {
      return _.orderBy(this.best_week, 'weight')
    },
    methods: {

        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        onLoad(e){
          const img = e.target;
          let width = 0;
          if (img.fileSize > 0 || (img.width > 1 && img.height > 1)) {
            width = img.width + 40;
          }
          this.width = width + 'px';
        },

        handleAvatarSuccess(res) {
            this.info.imagefile = res.data;
            this.$forceUpdate();
        },
        /**
         * 设置楼层导航事件驱动方法
         * @param {Number} index  楼层下标
         */
        setFloorNavMountClick (index) {
          const { floor_item } = this.element
          const floor_offsetTop = floor_item[index].offsetTop - floor_item[0].offsetTop,
            window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop,
            timer = {
              step: 60,
              times: 16,
              FLOOR_OFFSETTOP: floor_offsetTop,
            }
          if (window_scrollTop > floor_offsetTop) {
            this.setFloorScrollArrowUp(timer)
          } else if (window_scrollTop == floor_offsetTop) {
            return false
          } else {
            this.setFloorScrollArrowDown(timer)
          }
        },
        /**
         * 设置楼层向上滚动
         * @param {Object} timer 定时器配置
         */
        setFloorScrollArrowUp (timer) {
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            if (window_scrollTop <= timer.FLOOR_OFFSETTOP) {
              document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP
              document.body.scrollTop = timer.FLOOR_OFFSETTOP
              clearInterval(this.timer)
            } else {
              document.documentElement.scrollTop = window_scrollTop - timer.step
              document.body.scrollTop = window_scrollTop - timer.step
            }
          }, timer.times)
        },
        /**
         * 设置楼层向下滚动
         * @param {Object} timer 定时器配置
         */
        setFloorScrollArrowDown (timer) {
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            let window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            if (window_scrollTop >= timer.FLOOR_OFFSETTOP) {
              document.documentElement.scrollTop = timer.FLOOR_OFFSETTOP
              document.body.scrollTop = timer.FLOOR_OFFSETTOP
              clearInterval(this.timer)
            } else {
              document.documentElement.scrollTop = window_scrollTop + timer.step
              document.body.scrollTop = window_scrollTop - timer.step
            }
          }, timer.times)
        },
        /**
         * 监听窗口滚动楼层导航动态定位
         */
        floorSrcollEventListener () {
          const { nav_item, floor_item } = this.element
          const window_scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          for (let i = 0, len = floor_item.length; i < len; i++) {
            let floor_offsetTop = floor_item[i].offsetTop - floor_item[0].offsetTop
            if (window_scrollTop >= floor_offsetTop) {
              for (let n = 0, len = nav_item.length; n < len; n++) {
                const current_classList = nav_item[n].classList
                i === n
                  ? current_classList.add('active')
                  : current_classList.remove('active')
              }
            }
          }
        },
        // 获取首页信息
        // get_index_info:function(){
        //     this.$get(this.$api.homeGetIndexInfo).then(res=>{
        //         //this.banner_list = res.data.banner.adv;  //原banner
        //         this.banner_bottom_adv = res.data.banner_bottom_adv.adv;
        //         this.goods_list = res.data.goods_list;
        //         this.goods_list_left_adv = res.data.goods_list_left_adv.adv;
        //         this.goods_list_bottom_adv = res.data.goods_list_bottom_adv.adv;
        //         this.seckill_goods_list = res.data.seckill_goods;
        //         this.seckill_info = res.data.seckill_info;
        //         this.showAdver1 = res.data.showAdver1.adv;
        //     });
        // },
        //banner
        // get_banner_list:function(){
        //     this.$get(this.$api.banner_list).then(res=>{
        //         this.banner_list = res.data.list;
        //     });
        // },
         //轮播
        // get_banner_list:function(){
        //     this.$get(this.$api.showAdver+10).then(res=>{
        //       if(res.code == 200){
        //         if(res.data != null){
        //           this.banner_list = res.data.list;
        //         }
        //       }
        //     });
        // },

        //本周优选
        // get_best_week:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTc='}).then(res=>{
        //       if(res.code == 200){
        //         this.best_week = res.data.list[0].indexGoodsParamList;
        //       }
        //     });
        // },

        // 获取本地弹窗次数
        get_popup_num:function(){
            // localStorage.setItem("popup_num",0); 
            // localStorage.setItem("popup_num",parseInt(localStorage.getItem('popup_num')) + 1); 
             localStorage.setItem("popup_num",localStorage.getItem('popup_num') + 1); 
            // console.log(localStorage.getItem('popup_num'));
            if(this.popup == null){
              this.dialogVisible = false;
            }else if(localStorage.getItem('popup_num') > 2){
              this.dialogVisible = false;
            }else{
              this.dialogVisible = true;
            }
        },


        //首页专题
        get_index_subject:function(){
          this.$get(this.$api.indexSubject,{subjectId:'11,12,13,14,15,16,17,37,38,39,47'}).then(res=>{
            if(res.code == 200){
              if(res.data != ''){
                for (let i = 0; i < res.data.length; i++){
                  //新品推荐
                  if(res.data[i].subject_id == 11){
                    this.newproduct_list = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //为你推荐
                  if(res.data[i].subject_id == 12){
                    this.recommend_list = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //家庭保健
                  if(res.data[i].subject_id == 13){
                    this.family_health = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //中药饮片
                  if(res.data[i].subject_id == 14){
                    this.tcm_list = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //家用器械
                  if(res.data[i].subject_id == 15){
                    this.household_list = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //中医器械
                  if(res.data[i].subject_id == 16){
                    this.apparatus_list = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //本周优选
                  if(res.data[i].subject_id == 47){
                    this.best_week = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });

                  }
                  //限时秒杀
                  if(res.data[i].subject_id == 17){
                    this.seckill = res.data[i].indexGoodsParamList.sort((a,b)=>{
                         return b.weight - a.weight;
                    });
                    if(res.data[i].useend){
                      this.start_time = res.data[i].usebegin;
                      this.end_time = res.data[i].useend;
                          if(this.intvalobj != null){
                              clearInterval(this.intvalobj);
                          }
                          this.intvalobj = setInterval(()=>{
                              let start_time = new Date(Date.parse(this.start_time.replace(/-/g,"/"))).getTime() / 1000;
                              let end_time = new Date(Date.parse(this.end_time.replace(/-/g,"/"))).getTime() / 1000;
                              let timestamp = Date.parse(new Date()) / 1000;
                              // console.log(start_time);
                              // console.log(end_time);
                              // console.log(timestamp);
                              if(start_time>timestamp){
                                  let sec = start_time-timestamp;
                                  this.hour = Math.floor(sec/3600);
                                  this.min = Math.floor((sec-(this.hour*3600))/60);
                                  this.secs = sec-(this.hour*60+this.min)*60;
                                  this.fontSkill = '开始';
                              }else if(end_time>timestamp){
                                  let sec2 = end_time-timestamp;
                                  this.hour = Math.floor(sec2/3600);
                                  this.min = Math.floor((sec2-(this.hour*3600))/60);
                                  this.secs = sec2-(this.hour*60+this.min)*60;
                                  this.fontSkill = '结束';
                              }else{
                                  this.hour = 0;
                                  this.min = 0;
                                  this.secs = 0;
                                  clearInterval(this.intvalobj);
                                  this.skillShow = false;
                              }
                          },1000);
                    }else{
                      this.skillShow = false;
                    }

                  }
                  //药店热销
                  if(res.data[i].subject_id == 37){
                    this.drugstore_sales = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //诊所常卖
                  if(res.data[i].subject_id == 38){
                    this.clinic_sells = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                  //精品控销
                  if(res.data[i].subject_id == 39){
                    this.control_sales = res.data[i].indexGoodsParamList.sort((a,b)=>{
                          return b.weight - a.weight;
                    });
                  }
                }
              }else{
                this.newproduct_list = null;
                this.recommend_list = null;
                this.family_health = null;
                this.tcm_list = null;
                this.household_list = null;
                this.apparatus_list = null;
                this.best_week = null;
                this.seckill = null;
                this.drugstore_sales = null;
                this.clinic_sells = null;
                this.control_sales = null;
              }



            }else if(res.code == 401){
                    this.$message.error(res.message);
                    localStorage.removeItem('token');
                    this.$router.push('/user/login/');
                }else{
                    this.$router.push('/user/login/');
                }

          });
        },


        start_time:function(){
            if(this.intvalobj != null){
                clearInterval(this.intvalobj);
            }
            this.intvalobj = setInterval(()=>{
                // let start_time = this.start_time;
                // let end_time = this.end_time;
                let timestamp = Date.parse(new Date())/1000;
                if(start_time>timestamp){
                    let sec = start_time-timestamp;
                    this.hour = Math.floor(sec/3600);
                    this.min = Math.floor((sec-(this.hour*3600))/60);
                    this.secs = sec-(this.hour*60+this.min)*60;
                    this.fontSkill = '开始';
                }else if(end_time>timestamp){
                    let sec2 = end_time-timestamp;
                    this.hour = Math.floor(sec2/3600);
                    this.min = Math.floor((sec2-(this.hour*3600))/60);
                    this.secs = sec2-(this.hour*60+this.min)*60;
                    this.fontSkill = '结束';
                }else{
                    this.hour = 0;
                    this.min = 0;
                    this.secs = 0;
                    clearInterval(this.intvalobj);
                }
            },1000);
        },



        // get_index_subject11:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'11'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //新品推荐
        //           if(res.data[i].subject_id == 11){
        //             this.newproduct_list = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject12:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'12'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //为你推荐
        //           if(res.data[i].subject_id == 12){
        //             this.recommend_list = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject13:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'13'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //家庭保健
        //           if(res.data[i].subject_id == 13){
        //             this.family_health = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject14:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'14'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //中药饮片
        //           if(res.data[i].subject_id == 14){
        //             this.tcm_list = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject15:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'15'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //家用器械
        //           if(res.data[i].subject_id == 15){
        //             this.household_list = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject16:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'16'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //中医器械
        //           if(res.data[i].subject_id == 16){
        //             this.apparatus_list = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject17:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'17'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //本周优选
        //           if(res.data[i].subject_id == 17){
        //             this.best_week = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject37:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'37'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //药店热销
        //           if(res.data[i].subject_id == 37){
        //             this.drugstore_sales = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject38:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'38'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //诊所常卖
        //           if(res.data[i].subject_id == 38){
        //             this.clinic_sells = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },
        // get_index_subject39:function(){
        //   this.$get(this.$api.indexSubject,{subjectId:'39'}).then(res=>{
        //     if(res.code == 200){
        //         for (let i = 0; i < res.data.length; i++){
        //           //精品控销
        //           if(res.data[i].subject_id == 39){
        //             this.control_sales = res.data[i].indexGoodsParamList;
        //           }
        //         }
        //     }
        //   });
        // },

        //限时秒杀
        // get_index_seckill:function(){
        //     this.$get(this.$api.index_seckill).then(res=>{
        //         this.index_seckill = res.data;
        //     });
        // },
        //药店热销
        // get_drugstore_sales:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDExMjBfMzc='}).then(res=>{
        //       if(res.code == 200){
        //         this.drugstore_sales = res.data.list[0].indexGoodsParamList;
        //       }
        //     });
        // },
        //诊所常卖
        // get_clinic_sells:function(){
        //     // this.$get(this.$api.clinic_sells).then(res=>{
        //     //     this.clinic_sells = res.data.list;
        //     // });
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDExMjBfMzg='}).then(res=>{
        //       if(res.code == 200){
        //         this.clinic_sells = res.data.list[0].indexGoodsParamList;
        //       }
        //     });
        // },
        //新品推荐轮播
        // get_newproduct_focus:function(){
        //     this.$get(this.$api.showAdver +11).then(res=>{
        //       if(res.code == 200){
        //         if(res.data != null){
        //           this.newproduct_focus = res.data.list;
        //         }
        //       }
        //     });
        // },



        //新品推荐
        // get_newproduct_list:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTE='}).then(res=>{
        //       if(res.code == 200){
        //         this.newproduct_list = res.data.list[0].indexGoodsParamList;
        //       }
        //     });
        // },



        //为你推荐
        // get_recommend_list:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTI='}).then(res=>{
        //       if(res.code == 200){
        //         this.recommend_list = res.data.list[0].indexGoodsParamList;
        //       }  
        //     });
        // },

        //精品控销
        // get_control_sales:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDExMjNfMzk='}).then(res=>{
        //       if(res.code == 200){
        //         this.control_sales = res.data.list[0].indexGoodsParamList;
        //       }
        //     });
        // },
        //家庭保健
        // get_family_health:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTM='}).then(res=>{
        //       if(res.code == 200){
        //         this.family_health = res.data.list[0].indexGoodsParamList;
        //       } 
        //     });
        // },
        //中药饮片
        // get_tcm_list:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTQ='}).then(res=>{
        //       if(res.code == 200){
        //         this.tcm_list = res.data.list[0].indexGoodsParamList;
        //       }   
        //     });
        // },
        //家用器械
        // get_household_list:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTU='}).then(res=>{
        //       if(res.code == 200){
        //         this.household_list = res.data.list[0].indexGoodsParamList;
        //       }
        //     });
        // },
        //中医器械
        // get_apparatus_list:function(){
        //     this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTY='}).then(res=>{
        //       if(res.code == 200){
        //         this.apparatus_list = res.data.list[0].indexGoodsParamList;
        //       }
        //     });
        // },
        //品牌专区
        get_brand_list:function(){
            this.$get(this.$api.brand_list).then(res=>{
                this.brand_list = res.data;
            });
        },

        get_market:function(){
            this.$get(this.$api.showAdver,{platId:this.$platId}).then(res=>{
              if(res.code == 200){
                for (let i = 0; i < res.data.list.length; i++){
                //轮播
                  if(res.data.list[i].id == 10){
                    this.banner_list = res.data.list[i].advertisementList;
                  }
                //领券中心下通栏
                  if(res.data.list[i].id == 6){
                    this.floor_ad_1 = res.data.list[i].advertisementList;
                  }
                  //弹窗
                  if(res.data.list[i].id == 12){
                    if(res.data.list[i].advertisementList != ''){
                      this.dialogVisible = true;
                      this.popup = res.data.list[i].advertisementList;
                    }
                  }
                  //右侧按钮
                  if(res.data.list[i].id == 17){
                    this.rightmenu1 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 18){
                    this.rightmenu2 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 19){
                    this.rightmenu3 = res.data.list[i].advertisementList;
                  }
                  //本周优选
                  if(res.data.list[i].id == 21){
                    this.button_menu1 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 22){
                    this.button_menu2 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 23){
                    this.button_menu3 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 24){
                    this.button_menu4 = res.data.list[i].advertisementList;
                  }
                  //促销专场
                  if(res.data.list[i].id == 13){
                    this.Promotion_1 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 14){
                    this.Promotion_2 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 15){
                    this.Promotion_3 = res.data.list[i].advertisementList;
                  }
                  if(res.data.list[i].id == 16){
                    this.Promotion_4 = res.data.list[i].advertisementList;
                  }
                  //为你推荐上通栏
                  if(res.data.list[i].id == 7){
                    this.floor_ad_2 = res.data.list[i].advertisementList;
                  }
                  //为你推荐下通栏
                  if(res.data.list[i].id == 8){
                    this.floor_ad_3 = res.data.list[i].advertisementList;
                  }
                  //中药饮片下通栏
                  if(res.data.list[i].id == 26){
                    this.floor_ad_4 = res.data.list[i].advertisementList;
                  }
                  //新品推荐下轮播
                  if(res.data.list[i].id == 11){
                    this.newproduct_focus = res.data.list[i].advertisementList;
                  }
                  //医疗器械方块
                  if(res.data.list[i].id == 27){
                    this.qixie_ad = res.data.list[i].advertisementList;
                  }
                  //女性健康方块
                  if(res.data.list[i].id == 28){
                    this.women_ad = res.data.list[i].advertisementList;
                  }
                  //精品控销
                  if(res.data.list[i].id == 29){
                    this.control_ad = res.data.list[i].advertisementList;
                  }
                  //家庭保健
                  if(res.data.list[i].id == 30){
                    this.homehelth_ad = res.data.list[i].advertisementList;
                  }
                  //中药饮片
                  if(res.data.list[i].id == 31){
                    this.tcm_ad = res.data.list[i].advertisementList;
                  }
                }

                this.get_popup_num();
                
              }else if(res.code == 401){
                    this.$message.error(res.message);
                    localStorage.removeItem('token');
                    this.$router.push('/user/login/');
                }else{
                    this.$router.push('/user/login/');
                }
            });
        },

  
        //公告
        get_announcement:function(){
            this.$get(this.$api.getNewsList,{pageSize:10,pageNum:1,type:"new_state",platId:this.$platId}).then(res=>{
              if(res.code == 200){
                this.announcement = res.data.list;
                this.total_data = res.data.total;
              }
            });
        },
        //更多公告
        viewMoreNews:function(){
          this.$router.push('/news/71?name=通知公告');
        }


    },
    created() {
        this.filepath();
        this.get_market();                     //广告位
        //this.get_index_seckill();              //限时秒杀
        // this.get_best_week();                  //本周优选
        // this.get_drugstore_sales();            //药店热销
        // this.get_clinic_sells();               //诊所常卖
        // this.get_newproduct_list();            //新品推荐
        // this.get_recommend_list();             //为你推荐
        // this.get_control_sales();              //精品控销
        // this.get_family_health();              //家庭保健
        // this.get_tcm_list();                   //中药饮片
        // this.get_household_list();             //家用器械
        // this.get_apparatus_list();             //中医器械
        this.get_index_subject();              //首页专题集合
        // this.get_index_subject11();
        // this.get_index_subject12();
        // this.get_index_subject13();
        // this.get_index_subject14();
        // this.get_index_subject15();
        // this.get_index_subject16();
        // this.get_index_subject17();
        // this.get_index_subject37();
        // this.get_index_subject38();
        // this.get_index_subject39();
        // this.get_banner_list();                //Banner
        // this.get_floor_ad_1();                 //领券中心下通栏
        // this.get_floor_ad_2();                 //为你推荐上通栏
        // this.get_floor_ad_3();                 //为你推荐下通栏
        this.get_announcement();                   //公告
        // this.get_newproduct_focus();           //新品推荐轮播
        // this.get_floor_popup();                //弹窗广告
        // this.get_Promotion_ad_1();             //促销专场1
        // this.get_Promotion_ad_2();             //促销专场2
        // this.get_Promotion_ad_3();             //促销专场3
        // this.get_Promotion_ad_4();             //促销专场4
        //轮播右侧三按钮
        // this.get_right_menu1();
        // this.get_right_menu2();
        // this.get_right_menu3();
        //本周优选下四个按钮广告
        // this.get_button_menu1();
        // this.get_button_menu2();
        // this.get_button_menu3();
        // this.get_button_menu4();
        //this.get_index_info();
        //this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
    },
    mounted() {
        // 监听滚动条
        window.addEventListener('scroll', ()=>{
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop>20){
                this.subnav_show = false;
            }else{
                this.subnav_show = true;
            }
        }, true);
        this.element = {
          nav_item: document.getElementsByClassName('nav-list-item'),
          floor_item: document.getElementsByClassName('floor-item')
        }
        this.element.nav_item[0].classList.add('active')
        window.addEventListener('scroll', this.floorSrcollEventListener)
    }, 
};
</script>
<style lang="scss" scoped>
.shop_content{
    background: #f5f5f5;
    padding:20px 0 20px 0;
    // width: 1200px;
    // margin: 0 auto;
    // margin-top:40px;
}
  .el-carousel__item .el-image {
    color: #475669;
    // opacity: 0.75;
    width: 369px;
    height: 450px;
    margin: 0;
  }
.setaxios {
    width: 1000px;
    margin: 20px auto;
    text-align: right;
}
.setaxios input[type=button] {
    text-align: center;
}
.floor-nav {
    position: fixed;
    top: 200px;
    /* left: 50px; */
    left:350px;
}
.floor-nav .nav-list {
    width: 48px;
    display: inline-block;
    text-align: center;
    background-color: #f8f8f8;
    padding: 5px 15px;
    /* background-color: red; */
}
.floor-nav .nav-list .nav-list-item {
    display: inline-block;
    width: 100%;
    height: 100%;
    line-height: 48px;
    vertical-align: middle;
    align-self: center;
    border-bottom: 1px solid #fff;
    cursor: pointer;
}
#floorNavList li.active,
#floorNavList li:hover {
    color: #FFF;
    background-color: rgb(64, 178, 238);
    /* color: red; */
}
.miaosha .product .el-image{
	width: 150px;
	height: 150px;
	margin: 20px 45px 10px 45px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    /* Firefox 4 */
    -webkit-transition: 0.2s all linear;
    /* Safari å’Œ Chrome */
    -o-transition: 0.2s all linear;
    /* Opera */
}
.miaosha .product  li:hover .el-image{
	transform: scale(1.1);
}
.tab-box .item .product .fl .el-image, .tab-box .item .product .fl  img {
	width: 98px;
	height: 98px;
	margin: 10px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    /* Firefox 4 */
    -webkit-transition: 0.2s all linear;
    /* Safari å’Œ Chrome */
    -o-transition: 0.2s all linear;
    /* Opera */
}
.tab-box .item .product li:hover .el-image, .tab-box .item .product li:hover img{
	transform: scale(1.1);
}
.newp .product li:first-child .el-image{
	width: 199px !important;
	height: 199px !important;
	margin: 10px 30px 10px 30px !important;
}
.newp .product .fl .el-image{
	width: 110px;
	height: 110px;
	margin: 49px 10px 49px 10px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    /* Firefox 4 */
    -webkit-transition: 0.2s all linear;
    /* Safari å’Œ Chrome */
    -o-transition: 0.2s all linear;
    /* Opera */
}
.newp .product li:hover .el-image{
	transform: scale(1.1);
}
.focus .el-image{
  width: 369px;
  height: 450px;
}
.recommended .fr .rolling li .el-image{
	width: 150px;
	height: 150px;
	margin: 20px 15px 10px 15px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    /* Firefox 4 */
    -webkit-transition: 0.2s all linear;
    /* Safari å’Œ Chrome */
    -o-transition: 0.2s all linear;
    /* Opera */
}
.recommended .fr .rolling li:hover .el-image{
	transform: scale(1.1);
}
.cmedicine .product .fl .el-image{
	width: 120px;
	height: 120px;
	margin: 49px 10px 49px 10px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    /* Firefox 4 */
    -webkit-transition: 0.2s all linear;
    /* Safari å’Œ Chrome */
    -o-transition: 0.2s all linear;
    /* Opera */
}
.cmedicine .product li:hover .el-image{
	transform: scale(1.1);
}
.twocolumns .product .fl .el-image{
	width: 120px;
	height: 120px;
	margin: 25px 14px 25px 14px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    /* Firefox 4 */
    -webkit-transition: 0.2s all linear;
    /* Safari å’Œ Chrome */
    -o-transition: 0.2s all linear;
    /* Opera */
}
.twocolumns .product li:hover .el-image{
	transform: scale(1.1);
}
.twocolumn .product .fl .el-image{
    width: 120px;
    height: 120px;
    margin: 25px 14px 25px 14px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    -webkit-transition: 0.2s all linear;
    -o-transition: 0.2s all linear;
}
.twocolumn .product li:hover .el-image{
	transform: scale(1.1);
}
.twocolumns .products .fl .el-image{
    width: 120px;
    height: 120px;
    margin: 25px 14px 25px 14px;
    transition: 0.2s all linear;
    -moz-transition: 0.2s all linear;
    -webkit-transition: 0.2s all linear;
    -o-transition: 0.2s all linear;
}
.twocolumns .products li:hover .el-image{
	transform: scale(1.1);
}
</style>


<style>
.dialog .el-dialog {
    width: 400px !important;
}
.dialog .el-dialog__header {
    padding: 0px !important;
}
.dialog .el-dialog__body{
  padding: 0px !important;
}
.dialog .el-dialog__title{
  display: none;
}
.dialog .el-dialog__headerbtn {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
    background: #fff;
    width: 30px;
    height: 30px;
}
.more{
  float: right;
  cursor: pointer;
}
.more:hover{
  color: #409EFF;
}
</style>
